import axiosInstance from "@/utils/axiosInstance";

const baseUrl = `api/admin/administration`;

const state = {};

const getters = {};

const mutations = {};

const actions = {

  postProtectionState(_, payload: { params: {active: boolean }}) {
    return axiosInstance.post(
      `${baseUrl}/protection-is-ready/${payload.params.active}`,
    ).then((res) => res.data);
  },

  getProtectionState(_, __) {
    return axiosInstance.get(`${baseUrl}/protection-is-ready`)
      .then((res) => res.data);
  },

};

export default {
  namespaced: true, state, getters, actions, mutations,
};
